import { NavBar } from 'components/NavBar/NavBar'
import { clearClientRole, getSingleClientRole } from 'features/roles/clientRolesSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import {
  Button,
  Flex,
  H1WithBack,
  PageWrapper,
  Box,
  ThinSeparator,
  ItemsGrid,
} from 'styling/GlobalStyles'
import { AppDispatch, RootState } from 'store'
import { ISingleClientRoleGetResponse } from 'types/api/clientRoles.interface'
import { BodyText, OtherText, ParagraphText, TitleText } from 'styling/Typography'
import { days, shiftChangeTypes } from 'pages/Employees/employeesData'
import { ScheduleWeeklyCard } from 'pages/Shifts/Shifts.styled'
import { SunriseIcon } from 'pages/Shifts/Icons/SunriseIcon'
import { HeartIcon } from 'pages/Shifts/Icons/HeartIcon'
import { SunsetIcon } from 'pages/Shifts/Icons/SunsetIcon'
import { RotationIcon } from 'pages/Shifts/Icons/RotationIcon'
import { BeachIcon } from 'pages/Shifts/Icons/BeachIcon'
import { DrinkIcon } from 'pages/Shifts/Icons/DrinkIcon'
import { SunIcon } from 'pages/Shifts/Icons/SunIcon'
import { convertMinsToHrsMins } from 'utils/helpers'
import { useEffect } from 'react'
import { Container, ContainerContent } from 'components/Containers/Containers'
import { tokens } from 'styling/tokens'
import { MetricCard } from 'components/ui/MetricCard/MetricCard'

export const SingleRole = () => {
  const navigate = useNavigate()
  const { singleRole } = useSelector((store: RootState) => store.clientRoles)
  const { id } = useParams()
  const dispatch = useDispatch<AppDispatch>()
  const roleData = singleRole as unknown as ISingleClientRoleGetResponse

  useEffect(() => {
    dispatch(getSingleClientRole(id))

    return () => {
      dispatch(clearClientRole())
    }
  }, [dispatch, id])

  const getIcon = (icon: string, color: string) => {
    switch (icon) {
      case 'sunrise':
        return <SunriseIcon stroke={color || tokens.accent.base} />
      case 'sunset':
        return <SunsetIcon stroke={color || tokens.accent.base} />
      case 'rotation':
        return <RotationIcon stroke={color || tokens.accent.base} />
      case 'beach':
        return <BeachIcon stroke={color || tokens.accent.base} />
      case 'drink':
        return <DrinkIcon stroke={color || tokens.accent.base} />
      case 'sun':
        return <SunIcon stroke={color || tokens.accent.base} />
      case 'heart':
        return <HeartIcon stroke={color || tokens.accent.base} />
      default:
        return null
    }
  }

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between>
          <H1WithBack title={roleData?.name || 'Role Details'} arrow />
          <Button orange onClick={() => navigate('edit')}>
            Edit Role
          </Button>
        </Flex>
        {/* <TitleText weight='bold' style={{ fontSize: 24, lineHeight: '32px', marginTop: 32 }} >Work Schedule</TitleText> */}

        <Flex gap='1.625rem' mt='16' >
          <Flex width='100%' gap='1.625rem' column >
            <Flex column width='100%' >
              <Box width='100%' >
                <Flex gap='2rem' >
                  <Flex column width='100%'>
                    <TitleText weight='bold' style={{ fontSize: 18 }} >Work Schedule Model</TitleText>
                    <Flex width='100%' column >
                      <Flex width='100%' column>
                        <OtherText grey style={{ marginTop: '1rem' }}>SCHEDULE MODEL</OtherText>
                        <BodyText style={{ marginTop: '0.2rem' }} >{roleData?.workScheduleModel?.name || '-'}</BodyText>
                      </Flex>
                      <Flex width='100%' column>
                        <OtherText grey style={{ marginTop: '1rem' }}>FREE DAYS</OtherText>
                        <BodyText style={{ marginTop: '0.2rem' }} >{roleData?.freeDays?.length ? roleData?.freeDays?.map(d => days[d - 1].label).join(', ') : '-'}</BodyText>
                      </Flex>
                    </Flex>
                  </Flex>
                  <Flex width='100%' column>
                    <TitleText weight='bold' style={{ fontSize: 18 }} >Shift Configuration</TitleText>
                    <Flex width='100%' column>
                      <Flex width='100%' column>
                        <OtherText grey style={{ marginTop: '1rem' }}>SHIFT CHANGE TYPE</OtherText>
                        <BodyText style={{ marginTop: '0.2rem' }} >{shiftChangeTypes.find(s => s.value == roleData?.shiftChangeType)?.label || '-'}</BodyText>
                      </Flex>
                      <Flex width='100%' column>
                        <OtherText grey style={{ marginTop: '1rem' }}>SHIFT CHANGE INTERVAL</OtherText>
                        <BodyText style={{ marginTop: '0.2rem' }} >{roleData?.shiftChangeInterval || '-'}</BodyText>
                      </Flex>
                    </Flex>

                  </Flex>
                  <Flex width='100%' column >
                    <MetricCard label='Vacation days' value={String(roleData?.vacationDays ?? '-')} accentColor={tokens.accent.base} />
                  </Flex>
                </Flex>
                <ThinSeparator />
                <OtherText grey style={{ marginTop: '1rem' }}>SHIFTS</OtherText>
                <ItemsGrid columns={3} style={{ marginTop: '0.5rem' }} >
                  {roleData?.shifts?.map(({ shift }) => <ScheduleWeeklyCard key={shift.id} style={{ height: 60, width: '100%' }} color={'#' + shift.color} >
                    <Flex gap='0.5rem' center >
                      {getIcon(shift.icon, '#' + shift.iconColor)}
                      <Flex column >

                        <BodyText
                          style={{
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            maxWidth: '100%',
                            color: '#' + shift.textColor
                          }}
                          weight='bold' >{shift.name || 'Shift name'}
                        </BodyText>
                        <ParagraphText style={{ color: '#' + shift.textColor }} >
                          {convertMinsToHrsMins(shift.minutes)}-{convertMinsToHrsMins(shift.minutes, shift.shiftStart)}
                        </ParagraphText>
                      </Flex>
                    </Flex>
                  </ScheduleWeeklyCard>)}
                </ItemsGrid>
              </Box>
            </Flex>
            <Container>

              <ContainerContent>
                <OtherText grey style={{ marginBottom: '0.2rem' }}>POLICY NAME</OtherText>
                <BodyText >{roleData?.permissionPolicy?.policyName || '-'}</BodyText>
                <OtherText grey style={{ marginTop: '1rem', marginBottom: '0.2rem' }}>PERMISSIONS</OtherText>
                <ItemsGrid gap='0' mt='8px' columns={4} >{Object.keys(roleData?.permissions || {}).filter(p => roleData.permissions[p]).map(p => <BodyText key={p} >- {capitalizeFirstLetter(p)}</BodyText>)}</ItemsGrid>
              </ContainerContent>
            </Container>

          </Flex>
          {/* <TitleText weight='bold' style={{ fontSize: 24, lineHeight: '32px', marginTop: 32 }} >Permissions</TitleText> */}
          <Box width='100%' >
            <Flex column gap='1rem' >
              <TitleText weight='bold' style={{ fontSize: 18 }} >Welfare</TitleText>
              <Flex column gap='4px' >
                <OtherText grey >HAS TRANSPORTATION ALLOWANCE</OtherText>
                <BodyText >{roleData?.logisticsInfo?.hasTransportationAllowance ? 'Yes' : 'No'}</BodyText>
              </Flex>
              {roleData?.logisticsInfo?.hasTransportationAllowance && <>
                <Flex column gap='4px' >
                  <OtherText grey >TRANSPORTATION ALLOWANCE IN COMPANY AMOUNT</OtherText>
                  <BodyText>{roleData?.logisticsInfo?.transportationAllowanceInCompanyAmount}</BodyText>
                </Flex>
                <Flex column gap='4px' >
                  <OtherText grey >TRANSPORTATION ALLOWANCE OUT OF COMPANY AMOUNT</OtherText>
                  <BodyText >{roleData?.logisticsInfo?.transportationAllowanceOutCompanyAmount}</BodyText>
                </Flex>
              </>}
              <Flex column gap='4px' >
                <OtherText grey >HAS RESPONSIBILITY ALLOWANCE</OtherText>
                <BodyText  >{roleData?.logisticsInfo?.hasResponsibilityAllowance ? 'Yes' : 'No'}</BodyText>
              </Flex>
              {roleData?.logisticsInfo?.hasResponsibilityAllowance && <>
                <Flex column gap='4px' >
                  <OtherText grey >RESPONSIBILITY ALLOWANCE IN COMPANY AMOUNT</OtherText>
                  <BodyText >{roleData?.logisticsInfo?.responsibilityAllowanceInCompanyAmount}</BodyText>
                </Flex>
                <Flex column gap='4px' >
                  <OtherText grey >RESPONSIBILITY ALLOWANCE OUT OF COMPANY AMOUNT</OtherText>
                  <BodyText  >{roleData?.logisticsInfo?.responsibilityAllowanceOutCompanyAmount}</BodyText>
                </Flex>
              </>}
              <Flex column gap='4px' >
                <OtherText grey >HAS EXTRA DUTY ALLOWANCE</OtherText>
                <BodyText >{roleData?.logisticsInfo?.hasExtraDutyAllowance ? 'Yes' : 'No'}</BodyText>
              </Flex>
              {roleData?.logisticsInfo?.hasExtraDutyAllowance && <>
                <Flex column gap='4px' >
                  <OtherText grey >EXTRA DUTY ALLOWANCE IN COMPANY AMOUNT</OtherText>
                  <BodyText >{roleData?.logisticsInfo?.extraDutyAllowanceInCompanyAmount}</BodyText>
                </Flex>
                <Flex column gap='4px' >
                  <OtherText grey >EXTRA DUTY ALLOWANCE OUT OF COMPANY AMOUNT</OtherText>
                  <BodyText >{roleData?.logisticsInfo?.extraDutyAllowanceOutCompanyAmount}</BodyText>
                </Flex>
              </>}
            </Flex>
          </Box>
        </Flex>

      </PageWrapper >
    </>
  )
}

export function capitalizeFirstLetter(string: string) {
  if (string.length === 0) {
    return '';
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}